import Model, { attr, belongsTo } from '@warp-drive/legacy/model';
import { Type } from '@warp-drive/core-types/symbols';
import type PcsMerchantModel from './pcs-merchant.ts';
import type PcsNetworkMerchantModel from './pcs-network-merchant.ts';

export interface DataStateLogEntry {
  from: string;
  to: string;
  event: string;
  reason?: Record<string, unknown>;
  timestamp: string;
  user_id?: string | null;
}

export default class PcsMerchantNetworkMerchantModel extends Model {
  @attr declare dataState: string;
  @attr declare dataStateLog: DataStateLogEntry[];
  @attr declare deletedAt: string | null;
  @attr declare createdAt: string;
  @attr declare updatedAt: string;

  /*************************
   **  Relationships      **
   *************************/

  @belongsTo('pcs-merchant', { async: false, inverse: 'pcsMerchantNetworkMerchants' })
  declare pcsMerchant: PcsMerchantModel;

  @belongsTo('pcs-network-merchant', { async: false, inverse: 'pcsMerchantNetworkMerchants' })
  declare pcsNetworkMerchant: PcsNetworkMerchantModel;

  [Type] = 'pcs-merchant-network-merchant' as const;
}
